import React from 'react';
import { postAuthResult } from 'services/common';

const DevAuthFlow = () => {
  postAuthResult();

  return (
    <div className="coverall">
      <h3>(DEV) Auth Flow</h3>
    </div>
  );
};

export default DevAuthFlow;
